var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoChecklistIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7248 16.5542L14.3831 1.60417C13.8956 0.7375 12.9748 0.25 11.9998 0.25C11.0248 0.25 10.104 0.791667 9.61647 1.60417L1.2748 16.5542C0.787305 17.4208 0.787305 18.5042 1.2748 19.3708C1.7623 20.2375 2.68314 20.8333 3.65814 20.8333H20.3415C21.3706 20.8333 22.2373 20.2917 22.7248 19.3708C23.2123 18.5042 23.2123 17.4208 22.7248 16.5542ZM11.1873 6.20833C11.1873 5.775 11.5665 5.39583 11.9998 5.39583C12.4331 5.39583 12.7581 5.72083 12.8123 6.15417V13.25C12.8123 13.6833 12.4331 14.0625 11.9998 14.0625C11.5665 14.0625 11.2415 13.7375 11.1873 13.3042V6.20833ZM11.9998 18.125C11.404 18.125 10.9165 17.6375 10.9165 17.0417C10.9165 16.4458 11.404 15.9583 11.9998 15.9583C12.5956 15.9583 13.0831 16.4458 13.0831 17.0417C13.0831 17.6375 12.5956 18.125 11.9998 18.125Z",
    fill: "#F44336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoChecklistIcon);
export default __webpack_public_path__ + "static/media/so-checklist-icon.753ae920.svg";
export { ForwardRef as ReactComponent };